import { initialize } from "@epc-front/shared/services/splashScreen";

export const splashScreen = initialize();
